<template>
  <div class="modal" ref="modal" v-bind:class="{ 'is-active': is_active }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("tournament") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="title is-5">{{ $t("first tournament game") }}</div>
        <form>
          <div class="columns">
            <div class="column is-one-third">
              <div class="field">
                <label class="label">{{ $t("date") }}</label>
                <div class="control">
                  <input class="input" type="date" v-model="meta.date" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("headquarters") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.headquarters"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("number of players") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.number_of_players"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("gambling pit") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.gambling_pit"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="container">
              <div class="columns" v-if="meta.players && meta.players.length">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("first place") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.players[0].name"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("second place") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.players[1].name"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("third place") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.players[2].name"
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("score") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.players[pidx].score"
                      />
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </form>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="buttons">
          <button
            class="button is-primary is-rounded"
            @click="save"
            :disabled="is_form_invalid"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            <span class="icon">
              <i class="fa fa-close"></i>
            </span>
            <span>{{ $t("close") }}</span>
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import moment from "moment";
import GenericCalendar from "@/components/generic_calendar/Index.vue";

export default {
  name: "PokerTournamentGameModal",
  components: {
    GenericCalendar,
  },
  data() {
    return {
      is_active: false,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.date || !v.meta.number_of_players;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.is_active = false;
    },
    show_modal(tournament_uuid) {
      let v = this;
      v.set_initial_state();
      v.meta.tournament_uuid = tournament_uuid;
      v.is_active = true;
    },
    save() {
      let v = this;
      v.meta.settings = {};
      put("/tournament/poker", v.meta)
        .then(() => {
          v.$emit("success");
          v.is_active = false;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        players: [
          {
            name: "",
            score: 5,
          },
          {
            name: "",
            score: 3,
          },
          {
            name: "",
            score: 1,
          },
        ],
        number_of_players: 0,
        tournament_uuid: "",
      };
      v.error = "";
    },
  },
  mounted() {
    // let v = this;
  },
  watch: {
    "meta.number_of_players": function (val) {
      let v = this;
      v.meta.gambling_pit = val * 20;
    },
  },
};
</script>
<style scoped>
/* .modal-card {
  width: 90%;
} */
</style>
